import React from 'react';

import { useDeleteCG } from 'scenes/CountryGroups/data';

import Actions from './Actions';

const CGActions = ({ data, onEdit }) => {
  const [deleteCG] = useDeleteCG();

  const handleDelete = async () => await deleteCG(data);

  const handleEdit = () => onEdit?.(data);

  return <Actions data={data} onEdit={handleEdit} onDelete={handleDelete} />;
};

export default CGActions;
